import { render, staticRenderFns } from "./QForm.vue?vue&type=template&id=1a810e86&scoped=true&"
import script from "./QForm.vue?vue&type=script&lang=js&"
export * from "./QForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a810e86",
  null
  
)

export default component.exports